import React from "react";
import { Paper, Text, Flex, Container, useMantineTheme } from "@mantine/core";

export default function CenterLoadingOverlay({ content }) {
  const theme = useMantineTheme();
  const backgroundColor = theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white;
  
  return (
    <Container
      style={{
        height: "100vh",
        backgroundColor: backgroundColor,
        zIndex: 2000,
      }}
    >
      <Flex style={{ height: "100vh" }} align="center" justify="center">
        {content}
      </Flex>
    </Container>
  );
}
